import { type FunctionComponent } from 'react';
import { generateCloudinaryUrl } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import type { PromoBannerVariationOptions } from '../../../types/promo-banner.types';
import { StyledButton } from '../../buttons';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { BannerImage } from '../banner-image/banner-image.component';
import { DoorMarker } from '../promo-helpers/door-marker.component';
import { defaultCouponExpirationString } from '../promo-helpers/promo-banner.helpers';
import { SecondaryPromoE } from '../secondary-variations/secondary-promo-e.component';

export const PromoBannerE: FunctionComponent<PromoBannerVariationOptions> = (props) => {
	const { headline, subHeading, couponCode, expirationDate, action, image, imageShade, imageOverlay } = props;
	const backgroundUrl = generateCloudinaryUrl(image.id, {
		width: 1000,
		height: undefined,
		gravity: 'custom',
		zoom: '0.9',
		crop: 'thumb'
	});
	return (
		<>
			<div className="dn-ns">
				<SecondaryPromoE {...props} />
			</div>
			<BannerImage className="min-h4 pa3 dn db-ns" backgroundUrl={backgroundUrl} imageShade={imageShade || 'LIGHT'}>
				<div className="flex items-center">
					<div className="pr3 relative w-30-m w-20-l">
						{imageOverlay && (
							<CloudinaryImage
								publicID={imageOverlay.id}
								description="promo"
								className="center"
								options={{
									width: 120,
									height: undefined,
									crop: 'lfill',
									gravity: 'custom',
									preserveTransparency: true
								}}
								useDimensions={false}
							/>
						)}
					</div>
					<div className="pl3 w-70-m w-50-l">
						<div className="b f2 lh-solid theme-primary">{headline}</div>
						<div className="f4 lh-title mt3 theme-grey-darker">{subHeading}</div>
						{(couponCode || expirationDate) && (
							<div className="mt3 theme-grey-darker">
								<DoorMarker />
								<span className="nowrap">{defaultCouponExpirationString(couponCode, expirationDate)}</span>
							</div>
						)}
						{action && (
							<div className="mt3">
								{' '}
								<StyledButton>{action.name}</StyledButton>
							</div>
						)}
					</div>
					<div className="dn db-l w-30-l"></div>
				</div>
			</BannerImage>
		</>
	);
};
